var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcY(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.67,8.15a2,2,0,0,0-1.42-1.42A48.44,48.44,0,0,0,12,6.4a48.44,48.44,0,0,0-6.25.33A2,2,0,0,0,4.33,8.15,21.09,21.09,0,0,0,4,12a21.09,21.09,0,0,0,.33,3.85,2,2,0,0,0,1.42,1.42A48.44,48.44,0,0,0,12,17.6a48.44,48.44,0,0,0,6.25-.33,2,2,0,0,0,1.42-1.42A21.09,21.09,0,0,0,20,12,21.09,21.09,0,0,0,19.67,8.15ZM10.4,14.4V9.6L14.56,12Z",
    transform: "translate(-4 -6.4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcY);
export default __webpack_public_path__ + "static/media/ic_y.46d72ab5679175057696b7ea4818c8f8.svg";
export { ForwardRef as ReactComponent };